import { Component } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { faUserCircle, faLongArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { TicketService } from '../services/ticket.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {

  name: string;

  constructor(public auth: AuthService, public ticketService: TicketService) {}

  userCircle = faUserCircle;
  longArrowRight = faLongArrowRight
}
